<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="pagex">Abbreviations and Acronyms</a></h2><a id="pagex">
<table>
<tbody><tr>
<td><em class="italic">IK</em></td>
<td><em class="italic">Iskusstvo kino</em></td>
</tr>
<tr>
<td><em class="italic">LG</em></td>
<td><em class="italic">Literaturnaia gazeta</em></td>
</tr>
<tr>
<td><em class="italic">TMG</em></td>
<td><em class="italic">Moscow Guardian</em></td>
</tr>
<tr>
<td><em class="italic">TMT</em></td>
<td><em class="italic">Moscow Times</em></td>
</tr>
<tr>
<td><em class="italic">NYT</em></td>
<td><em class="italic">New York Times</em></td>
</tr>
<tr>
<td><em class="italic">NG</em></td>
<td><em class="italic">Nezavisimaia gazeta</em></td>
</tr>
<tr>
<td><em class="italic">SE</em></td>
<td><em class="italic">Sovetskii ekran</em></td>
</tr>
<tr>
<td>VDNKh</td>
<td>Exhibition of Economic Achievements</td>
</tr>
<tr>
<td>VGIK</td>
<td>All-Union State Institute of Cinema</td>
</tr>
<tr>
<td>VNIIK</td>
<td>All-Union Scientific Research Institute of Film Art</td>
</tr>
<tr>
<td><em class="italic">WP</em></td>
<td><em class="italic">Washington Post</em></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbreviations.vue?33faa02b